import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { SOSButton, SOSButtonConfig } from "./SOSButton";

export interface BaseActionsGridProps {
  // Translation (full namespace-prefixed key like "mindcotine:actions.title")
  titleKey: string;
  titleFallback: string;
  
  // Action cards (passed as children)
  children: ReactNode;
  
  // Optional SOS button config
  sosConfig?: SOSButtonConfig;
}

export function BaseActionsGrid({
  titleKey,
  titleFallback,
  children,
  sosConfig,
}: BaseActionsGridProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">{t(titleKey, titleFallback)}</h3>
      </div>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {children}
        {sosConfig && <SOSButton config={sosConfig} />}
      </div>
    </div>
  );
}
